/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LoginWithEmailAndPasswordChallengeResponse } from './LoginWithEmailAndPasswordChallengeResponse';
import {
    instanceOfLoginWithEmailAndPasswordChallengeResponse,
    LoginWithEmailAndPasswordChallengeResponseFromJSON,
    LoginWithEmailAndPasswordChallengeResponseFromJSONTyped,
    LoginWithEmailAndPasswordChallengeResponseToJSON,
} from './LoginWithEmailAndPasswordChallengeResponse';
import type { LoginWithEmailAndPasswordSuccessResponse } from './LoginWithEmailAndPasswordSuccessResponse';
import {
    instanceOfLoginWithEmailAndPasswordSuccessResponse,
    LoginWithEmailAndPasswordSuccessResponseFromJSON,
    LoginWithEmailAndPasswordSuccessResponseFromJSONTyped,
    LoginWithEmailAndPasswordSuccessResponseToJSON,
} from './LoginWithEmailAndPasswordSuccessResponse';

/**
 * @type AuthControllerLoginWithEmailAndPassword200Response
 * 
 * @export
 */
export type AuthControllerLoginWithEmailAndPassword200Response = { authFlow: 'CHALLENGE' } & LoginWithEmailAndPasswordChallengeResponse | { authFlow: 'LOGIN' } & LoginWithEmailAndPasswordSuccessResponse;

export function AuthControllerLoginWithEmailAndPassword200ResponseFromJSON(json: any): AuthControllerLoginWithEmailAndPassword200Response {
    return AuthControllerLoginWithEmailAndPassword200ResponseFromJSONTyped(json, false);
}

export function AuthControllerLoginWithEmailAndPassword200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthControllerLoginWithEmailAndPassword200Response {
    if (json == null) {
        return json;
    }
    switch (json['authFlow']) {
        case 'CHALLENGE':
            return Object.assign({}, LoginWithEmailAndPasswordChallengeResponseFromJSONTyped(json, true), { authFlow: 'CHALLENGE' } as const);
        case 'LOGIN':
            return Object.assign({}, LoginWithEmailAndPasswordSuccessResponseFromJSONTyped(json, true), { authFlow: 'LOGIN' } as const);
        default:
            return json;
    }
}

export function AuthControllerLoginWithEmailAndPassword200ResponseToJSON(json: any): any {
    return AuthControllerLoginWithEmailAndPassword200ResponseToJSONTyped(json, false);
}

export function AuthControllerLoginWithEmailAndPassword200ResponseToJSONTyped(value?: AuthControllerLoginWithEmailAndPassword200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    switch (value['authFlow']) {
        case 'CHALLENGE':
            return Object.assign({}, LoginWithEmailAndPasswordChallengeResponseToJSON(value), { authFlow: 'CHALLENGE' } as const);
        case 'LOGIN':
            return Object.assign({}, LoginWithEmailAndPasswordSuccessResponseToJSON(value), { authFlow: 'LOGIN' } as const);
        default:
            return value;
    }
}

